import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants.js'
import Swiper, { A11y, Controller, Navigation, Manipulation } from 'swiper'

Swiper.use([A11y, Controller, Navigation, Manipulation])

const SELECTORS = {
  controllerSection: '.js-controller-carousel',
  controllerImage: '.js-controller-carousel__image',
  controllerThumbs: '.js-controller-carousel__thumbnails__swiper',
  controllerThumbData: '.js-controller-carousel__thumbnails__data',
  controllerActive: '.js-controller-carousel__thumbnails__data--active',
  controllerIndex: '.js-controller-carousel__thumbnails__data--index',
  controllerLength: '.js-controller-carousel__thumbnails__data--length',
  navNext: '.js-controller-carousel__thumbnails--next',
  navPrev: '.js-controller-carousel__thumbnails--prev',
  storyBtn: '.js-nested-modal__outer__open-btn'
}

class ControllerCarousel {
  constructor (element) {
    this.element = element
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.controllerImage = this.element.querySelector(SELECTORS.controllerImage)
    this.controllerThumbData = this.element.querySelector(SELECTORS.controllerThumbData)
    this.controllerThumbs = this.element.querySelector(SELECTORS.controllerThumbs)
    this.controllerActive = this.element.querySelector(SELECTORS.controllerActive)
    this.controllerIndex = this.element.querySelector(SELECTORS.controllerIndex)
    this.controllerLength = this.element.querySelector(SELECTORS.controllerLength)
    this.navNext = this.element.querySelector(SELECTORS.navNext)
    this.navPrev = this.element.querySelector(SELECTORS.navPrev)
    this.exclude = ['Ally']
    this.data = null
    this.dataLength = null
    this.swiperSlides = null
    this.storyBtn = this.element.querySelector(SELECTORS.storyBtn)

    this.init()
  }

  init() {
    this.registerEvents()
  }

  registerEvents() {
    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.PRIDE_DATA_LOADED, (data) => {
      this.data = data
      this.dataLength = Object.keys(this.data).length - this.exclude.length
      this.controllerLength.innerHTML = this.dataLength
      this.createCarousel()
    })
  }

  createCarousel() {
    this.thumbnails = new Swiper(this.controllerThumbs, {
      a11y: {
        prevSlideMessage: 'Navigate to the previous flag and story',
        nextSlideMessage: 'Navigate to the next flag and story'
      },
      centeredSlides: true,
      centeredSlidesBounds: true,
      loop: true,
      loopedSlides: this.dataLength, // this controls duplication so it doesn't break initial order
      slidesPerView: 3,
      spaceBetween: 20,
      slideToClickedSlide: true,
      threshold: 10,
      navigation: {
        nextEl: this.navNext,
        prevEl: this.navPrev
      },
      breakpoints: {
        767: {
          slidesPerView: 5
        }
      }
    })

    this.appendThumbs()

    this.thumbnails.on('slideChangeTransitionEnd', e => {
      this.updateSlideData()
      this.setCurrentFlag()
    })
  }

  appendThumbs() {
    const thumbnailPromise = new Promise((resolve, reject) => {
      this.data.forEach((item, index, array) => {
        if (!this.exclude.includes(item.name)) {
          let flagThumbnail = `<div class="swiper-slide" data-name="${item.name}">`
          flagThumbnail += `<img class="swiper-slide__flag" src='${unlocked.theme_dir}${item.flagAsset}' alt='${item.name} Flag'/>`
          if (item.interview.portrait) flagThumbnail += `<img class="swiper-slide__portrait" src='${unlocked.theme_dir}${item.interview.portrait}' alt='${item.interview.name}'/>`
          flagThumbnail += '</div>'
          this.thumbnails.appendSlide(flagThumbnail)
        }

        if (index === array.length - 1) resolve()
      })
    })

    thumbnailPromise.then(() => {
      this.thumbnails.slideToLoop(this.dataLength) // sets the thumbnails to pride flag on page load
    })
  }

  updateSlideData() {
    this.controllerIndex.innerHTML = this.thumbnails.realIndex + 1
    this.controllerActive.innerHTML = this.thumbnails.slides[this.thumbnails.activeIndex].dataset.name
  }

  setCurrentFlag() {
    const currSlideIndex = this.thumbnails.realIndex
    const currentSlide = this.thumbnails.slides[currSlideIndex]
    const currentFlag = currentSlide.dataset.name
    const currObj = this.data.filter(obj => { return obj.name === currentFlag })
    this.currentFlagObj = currObj[0]

    this.storyBtn.dataset.flag = this.currentFlagObj.name // set story btn data
    this.controllerImage.alt = `Xbox Controller with ${this.currentFlagObj.name} Flag` // sets controller alt text
    this.controllerImage.src = `${unlocked.theme_dir}${this.currentFlagObj.controllerAsset}` // sets controller image
  }
}

/**
 * Add module objects alphabetically as needed
 * {
 *  selector: CSS selector for the target element(s)
 *  Source: Imported js class with a constructor. Constructor will be passed
 *      the target DOM element.
 * }
 */
export default {
  selector: SELECTORS.controllerSection,
  Source: ControllerCarousel
}
